module.exports = __webpack_public_path__ + "static/media/tutorial_en_1.31613865.png";